import { createContext, useContext } from 'react'

export const WealthOwnerClientsTableContext = createContext({
  editing: false
})

export const useWealthOwnerClientsActions = () => {
  return useContext(WealthOwnerClientsTableContext)
}
